import { formatCurrency } from "../../../../../shared/utils/formatCurrency";
import { calcularIva } from "../../../shared/iva";
import styles from "../../styles/addInvoice.module.css";

const fmtUSD = (n) =>
  Number(n || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  });

export default function FilialDetailsSummary({ invoiceData }) {
  const moneda     = invoiceData.moneda || "CRC";
  const tc         = Number(invoiceData.tipo_cambio) || 1;
  // `monto` es el valor digitado; el desglose depende del modo.
  const { base, iva, total } = calcularIva(
    Number(invoiceData.monto) || 0,
    invoiceData.tasa_iva,
    invoiceData.iva_incluido,
    invoiceData.iva_modo || "SUMAR",
  );
  const monto      = total;
  const montoCRC   = moneda === "USD" ? monto * tc : monto;
  const aplicaIva  = !!invoiceData.iva_incluido && iva > 0;

  return (
    <div className={styles["filial-details-summary"]}>
      <div className={styles["filial-summary-relevant"]}>
        <h2>RESUMEN RÁPIDO</h2>

        {/* Moneda */}
        <div className="d-flex justify-content-between align-items-center">
          <span>Moneda</span>
          <span style={{
            fontWeight: 700,
            color: moneda === "USD" ? "#60a5fa" : "#f97316",
            background: moneda === "USD" ? "rgba(96,165,250,0.12)" : "rgba(249,115,22,0.12)",
            border: `1px solid ${moneda === "USD" ? "rgba(96,165,250,0.3)" : "rgba(249,115,22,0.3)"}`,
            borderRadius: 4,
            padding: "1px 8px",
            fontSize: "0.8rem",
          }}>
            {moneda}
          </span>
        </div>

        {/* Tipo de cambio */}
        <div className="d-flex justify-content-between align-items-center">
          <span>Tipo de cambio</span>
          <span style={{ fontFamily: "monospace", color: "var(--text-secondary)" }}>
            ₡{fmtUSD(tc)} / USD
          </span>
        </div>

        {/* Desglose IVA */}
        {aplicaIva && (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <span style={{ fontSize: "0.82rem", color: "var(--text-muted)" }}>Base gravable</span>
              <span style={{ fontFamily: "monospace", color: "var(--text-secondary)", fontSize: "0.85rem" }}>
                {moneda === "USD" ? "$" : "₡"}{fmtUSD(base)}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span style={{ fontSize: "0.82rem", color: "var(--text-muted)" }}>
                IVA ({Number(invoiceData.tasa_iva)}%)
              </span>
              <span style={{ fontFamily: "monospace", color: "var(--text-secondary)", fontSize: "0.85rem" }}>
                {moneda === "USD" ? "$" : "₡"}{fmtUSD(iva)}
              </span>
            </div>
          </>
        )}

        {/* Monto en moneda original */}
        {moneda === "USD" && (
          <div className="d-flex justify-content-between align-items-center">
            <span>Total (USD)</span>
            <span style={{ fontFamily: "monospace", color: "#60a5fa", fontWeight: 600 }}>
              ${fmtUSD(monto)}
            </span>
          </div>
        )}

        {/* Equivalente en colones (si USD) */}
        {moneda === "USD" && (
          <div className="d-flex justify-content-between align-items-center">
            <span style={{ fontSize: "0.8rem", color: "var(--text-muted)" }}>
              Equiv. colones
            </span>
            <span style={{ fontFamily: "monospace", color: "var(--text-secondary)", fontSize: "0.85rem" }}>
              ₡{formatCurrency(montoCRC)}
            </span>
          </div>
        )}
      </div>

      <div className={styles["filial-summary-important"]}>
        <h2>Total a pagar</h2>
        {moneda === "USD" ? (
          <div style={{ textAlign: "right" }}>
            <span style={{ color: "#60a5fa", fontWeight: 700 }}>
              ${fmtUSD(monto)} USD
            </span>
            <div style={{ fontSize: "0.78rem", color: "var(--text-muted)", fontWeight: 400 }}>
              ≈ ₡{formatCurrency(montoCRC)}
            </div>
          </div>
        ) : (
          <span>₡ {formatCurrency(monto)}</span>
        )}
      </div>
    </div>
  );
}
